import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const OptInMsgIcon = (props: IconProps) => (
  <ChakraIcon viewBox="0 0 48 48" {...props}>
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M24,46 C36.1502645,46 46,36.1502645 46,24 C46,11.8497355 36.1502645,2 24,2 C11.8497355,2 2,11.8497355 2,24 C2,36.1502645 11.8497355,46 24,46 Z M38,24.0176 L30.4843655,34.0176 L23.646514,34.0176 L31.152937,24.0176 L23.646514,14.0176 L30.4843655,14.0176 L38,24.0176 Z M26.3534854,24.0176 L18.837851,34.0176 L12,34.0176 L19.5064224,24.0176 L12,14.0176 L18.837851,14.0176 L26.3534854,24.0176 Z"
    />
  </ChakraIcon>
)

export default OptInMsgIcon
